import { render, staticRenderFns } from "./open-banking-transfers.vue?vue&type=template&id=2b390f44"
import script from "./open-banking-transfers.vue?vue&type=script&lang=js"
export * from "./open-banking-transfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports